/**
 * Internal dependencies
 */
import reducer from './reducer';
import * as types from './types';
import * as actions from './actions';
import * as selectors from './selectors';

export default reducer;
export { types, actions, selectors };
